// extracted by mini-css-extract-plugin
module.exports = {"homeContainer":"homeContainer--7pXie","testAnimation":"testAnimation--1TELv"};